import ArticleListSection from '@/cmsComponents/ArticleListSection';
import { ArticlePromotion } from '@/cmsComponents/ArticlePromotion';
import React from 'react';
import { IArticlePromotion, IArticleSummary } from 'types/cms';

const END_OF_FIRST_TWO_COLUMNS_DATA = 9;

interface IProps {
  articles: IArticleSummary[];
  promotion?: IArticlePromotion | null;
}

export const ArticleResultLanding: React.FC<IProps> = ({ articles, promotion }) => {
  const firstPartAmount =
    articles.length < END_OF_FIRST_TWO_COLUMNS_DATA
      ? articles.length
      : END_OF_FIRST_TWO_COLUMNS_DATA;
  const firstTwoColumnsData = articles.slice(0, firstPartAmount);
  const restColumnsData = articles.slice(firstPartAmount);

  return (
    <>
      <ArticleListSection key="firstTwoColumn" articles={firstTwoColumnsData} />
      {promotion && <ArticlePromotion promotion={promotion} />}
      <ArticleListSection key="restArticles" articles={restColumnsData} />
    </>
  );
};
